module.exports = __webpack_public_path__ + "b7097100e1995a40dd21413040bd5277.png";